import React from "react";
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import { useImportActs } from "../../../../backend/masters";
import { download, downloadWithPresignedUrl, preventDefault } from "../../../../utils/common";
import { componentTypes } from "../../../common/FormRenderer";
import { EXCEL_FILE_REGEX, FILE_SIZE } from "../../../common/Constants";
import BaseImportModal from "../../../common/BaseImportModal";

function ActImportModal({ onClose }: any) {

    const schema = {
        fields: [
            {
                component: componentTypes.FILE_UPLOAD,
                label: 'Upload File',
                name: 'file',
                type: 'file',
                validate: [
                    { type: validatorTypes.REQUIRED },
                    { type: 'file-type', regex: EXCEL_FILE_REGEX },
                    { type: 'file-size', maxSize: 25 * FILE_SIZE.MB }
                ],
                description: <a href="/" onClick={downloadSample}>Dowload Sample Acts</a>
            },
        ],
    };

    function downloadSample(e: any) {
        preventDefault(e);
        downloadWithPresignedUrl('Sample Acts.xlsx', 'https://mafoi.s3.ap-south-1.amazonaws.com/bulkuploadtemplates/ActsTemplate.xlsx')
    }

    return (
        <BaseImportModal onClose={onClose} importSchema={schema} importFunction={useImportActs} title="Import Acts" />
    )
}

export default ActImportModal;
